import { Props } from "./RemoveFromCollectionIcon.Parts";

/** Folder with a minus, from the DLS 4.0 "remove icon". */
export const RemoveFromCollectionIcon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    {...props}
  >
    <path
      d="M18 2H9.414L7.707 0.293C7.51951 0.105451 7.26519 5.66374e-05 7 0H2C0.897 0 0 0.897 0 2V16C0 17.103 0.897 18 2 18H18C19.103 18 20 17.103 20 16V4C20 2.897 19.103 2 18 2ZM2 16V4H18L18.002 16H2Z"
      fill="currentColor"
    />
    <path d="M5.874 9H13.874V11H5.874V9Z" fill="currentColor" />
  </svg>
);
